import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useToggle from 'utils/customHooks/useToggle';
import Linkify from 'react-linkify';
import { DownArrow } from 'components/Icons';
import { InputGroup, FormControl } from 'react-bootstrap';

const MAX_CHARS_POST_DESC = 120;

const PostDescription = ({ post }) => {
  const [showFullDesc, setShowFullDesc] = useToggle();
  const infoRef = useRef(null);
  const [isLong, setIsLong] = useState(false);
  useEffect(() => {

    if ((infoRef.current && infoRef.current?.offsetHeight >= 100) || (infoRef?.current && MAX_CHARS_POST_DESC > 120)) {
      infoRef?.current.classList.add('hidden-info')
      setIsLong(true)

    }
    else {
      infoRef?.current.classList.remove('hidden-info')

    }

  }, [showFullDesc]);

  const checkHebrew = string => {
    return /[\u0590-\u05FF]/.test(string);
  };
  const { t } = useTranslation();
  return (
    <div
      className={` d-flex post-description-container ${checkHebrew(post.body) ? 'direction-rtl' : 'direction-ltr'} `}
    >
      <h5 className="text-light-gray font-size-12 mt-0 post-description-wrapper">

        <p ref={infoRef}
          className="post-description-wrapper-pre " >
          <Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <a target="blank" href={decoratedHref} key={key}>
                {decoratedText}
              </a>
            )}
          >
            {showFullDesc ? post?.body?.replace(/\r?\n/g, '\n') : post?.body?.replace(/\r?\n/g, '\n').substr(0, 120)}

          </Linkify>
        </p>
        {isLong ? (
          <span className={'post-description-btn'} onClick={setShowFullDesc}>
            {showFullDesc ? t('less_info') : t('more_info')}
            {showFullDesc ? (
              <DownArrow fill="#36CFFF" style={{ transform: 'rotate(180deg)', marginLeft: '14px' }} />
            ) : (
              <DownArrow fill="#36CFFF" style={{ marginLeft: '14px' }} />
            )}
          </span>
        ) : null}
      </h5>
    </div>
  );
};

export default PostDescription;
